import request from "@/utils/request.js";
// 数据查询列表
export const tablelist = data => {
  return request({
    url: "/apiData/hz-data-community/table/List",
    data: data || {},
    method: 'POST'
  });
};
// 数据查询-字段配置保存
export const configureSave = data => {
  return request({
    url: "/apiData/hz-data-community/table/field/configure/save",
    data: data || {},
    method: 'POST'
  });
};
// 数据查询-字段配置查询
export const configureList = data => {
  return request({
    url: "/apiData/hz-data-community/table/field/configure/list",
    data: data || {},
    method: 'POST'
  });
};

// 数据查询-字段配置删除
export const configureDetele = data => {
  return request({
    url: "/apiData/hz-data-community/table/field/configure/detele",
    data: data || {},
    method: 'POST'
  });
};